import type { ReactElement } from "react"
import TextAtm from "@onestore/hel/dist/components/atoms/TextAtm"
import FlexContainerOrg from "@onestore/hel/dist/components/organisms/FlexContainerOrg"
import PushOrg from "@onestore/hel/dist/components/organisms/PushOrg"
import ConditionalWrapper from "@onestore/hel/dist/helpers/ConditionalWrapper"
import useBreakpoint from "@onestore/hel/dist/hooks/useBreakpoint"
import _t from "@core/i18n"
import CtaSectionsModal from "@gatsby-plugin-generic-page/components/CtaSectionsModal"
import type { CtaSectionsModal as CtaSectionsModalProps } from "@gatsby-plugin-generic-page/fragments/ctaSectionsModal"
import Tooltip from "~/components/Tooltip"
import { usePriceTypeContext } from "~/context/PriceTypeContext"
import isEmpty from "~/lib/isEmpty"

interface FooterProps {
  sortingTooltipContent?: string | null
  ctaSectionsModal?: CtaSectionsModalProps
}

export function Footer({
  sortingTooltipContent,
  ctaSectionsModal,
}: FooterProps): ReactElement | null {
  const isMediumUp = useBreakpoint("medium")
  const { isNettoPriceType } = usePriceTypeContext()

  return (
    <PushOrg topSpace={1}>
      <ConditionalWrapper
        condition={
          !isEmpty(ctaSectionsModal) || !isEmpty(sortingTooltipContent)
        }
        wrapper={(children) => (
          <FlexContainerOrg
            alignItems="center"
            justifyContent="space-between"
            direction={isMediumUp ? undefined : "column"}
          >
            {!isEmpty(ctaSectionsModal) ? (
              <CtaSectionsModal {...ctaSectionsModal[0]} />
            ) : null}

            {!isEmpty(sortingTooltipContent) ? (
              <Tooltip
                labelTypography="nano1"
                labelEmphasis="high"
                iconSize="small"
                labelText={_t("domainSearch.mainDomainSortInfoLabel")}
              >
                {sortingTooltipContent}
              </Tooltip>
            ) : null}

            {children}
          </FlexContainerOrg>
        )}
      >
        <TextAtm
          typography="nano1"
          emphasis="medium"
          align={isMediumUp ? "right" : "center"}
        >
          {isNettoPriceType
            ? _t("domainSearch.mainDomainNoTaxFooter")
            : _t("domainSearch.mainDomainTaxFooter")}
        </TextAtm>
      </ConditionalWrapper>
    </PushOrg>
  )
}
